/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { Button, filledInputClasses, Grid, Typography } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import MaterialTable from '@material-table/core';
import MainCard from '../../ui-component/cards/MainCard';
import SecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import { gridSpacing } from '../../store/constant';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Flatpickr from 'react-flatpickr';
import { Link } from 'react-router-dom';
import { Label, Tooltip } from 'reactstrap';
import configData from '../../config';

import uploadCloud from '../../assets/images/icons/cloud-upload-svgrepo-com.svg';
import moment from 'moment';

import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { IconCloudUpload, IconMail, IconPhone, IconDownload } from '@tabler/icons';

import { Divider } from '@mui/material';
import axiosInstance from '../../axiosInstance';
import { useSelector, useDispatch } from 'react-redux';
import { ORG_DATA } from '../../store/actions';
import { height } from '@mui/system';

const states = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Dubai',
];

const Industry = [
    'Automotive',
    'Construction',
    'Engineering',
    'Food Services',
    'Health Care',
    'Mining and Logistics',
    'Technology',
    'Telecommunication',
    'Paper Industry',
    'Service Industry'
];

function CasingDamageReport() {
    const [selectedFile, setSelectedFile] = useState();
    const [openingSheet, setOpeningSheet] = useState();
    const [roles, setRoles] = useState();
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const org_id = useSelector((state) => (state?.account?.org?.id ? state?.account?.org?.id : state?.account?.org_data?.data?.id));

  
    const dispatch = useDispatch();
    const role = useSelector((state) => state?.account?.role);
    const isOrgMemberFlag = useSelector((state) => state?.account.org_member?.isOrgUpdated);
    const logoUrl = useSelector((state) => state?.account?.org?.logo_url);
    const org = useSelector((state) => state?.account?.org);
    const org_data = useSelector((state) => state?.account?.org_data?.data);
    const org_member_data = useSelector((state) => state?.account?.org_data?.org_member_data);
    const org_member = useSelector((state) => state?.account?.org_member);
    const loggedInUser = useSelector((state) => state?.account?.user?.email);

    console.log("Rendering CasingDamageReport...");
    console.log("Role:", role);
    console.log("org_data:", org_data);
    console.log("org_member:", org_member);
    console.log("org_member_data:", org_member_data);
    // Toggle tooltip visibility
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

    const {
        control,
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm({
        defaultValues: {
            state: '',
            industry: '',
            email: ''
            // password: ''
        }
    });

    const onSubmit = async (data) => {
        const formData = new FormData();

        // Append data fields to the FormData object
        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });

        if (selectedFile) {
            formData.append('file', selectedFile);
        }

        formData.append('user', loggedInUser);
        data.user = loggedInUser;
        // console.log(data);
        try {
            // const res = await axiosInstance.post('http://127.0.0.1:8000/organization/updateOrgDetails', formData);
            const res = await axiosInstance.post(configData.API_SERVER+'/organization/updateOrgDetails', formData);
            console.log('Response:', res);
            alert(res.data.message);
            dispatch({
                type: ORG_DATA,
                payload: {
                    org_data: res.data
                }
            });
            const org_id_data = {
                org_id: res.data.data.id
            }
            const updateCoa = await axiosInstance.post(`https://api.projectivetech.com/account/assign_default_coa`, org_id_data)
            // const updateCoa = await axiosInstance.post(`http://127.0.0.1:8000/account/assign_default_coa`, org_id_data)
            console.log(updateCoa);
        } catch (error) {
            // Handle error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log('Error response data:', error.response.data);
                console.log('Error response status:', error.response.status);

                // Check if the error is a result of email duplication
                if (error.response.status === 400 && error.response.data.message) {
                    // Display the error message to the user
                    alert(error.response.data.message);
                } else {
                    // Handle other types of errors accordingly
                    alert('Other error:', error.response.data);
                }
            } else if (error.request) {
                // The request was made but no response was received
                alert('Error request:', error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                alert('Error message:', error.message);
            }
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        console.log(file);
        const fileType = file.type;
        if (fileType !== 'image/png' && fileType !== 'image/jpeg' && fileType !== 'image/jpg') {
            alert('Supported formats: PNG, JPEG, JPG');
            return;
        }
        // Check file size
        const fileSize = file.size; // in bytes
        const maxSize = 1 * 1024 * 1024; // 1 MB
        if (fileSize > maxSize) {
            alert('Maximum File Size: 1MB');
            return;
        }
        setSelectedFile(file);
    };

    const handleUpload = () => {
        // Check if a file is selected
        if (selectedFile) {
            // Check file type

            // If file type and size are within limits, you can proceed with handling the file
            // For example, you can upload the file to the server or perform other actions
            // You can use FormData to append the file and send it via an API request
            const formData = new FormData();
            formData.append('file', selectedFile);
            console.log(selectedFile);

            // Your API call or other file handling logic goes here
            // For example:
            // axiosInstance.post('/upload', formData).then(response => {
            //   console.log(response.data);
            // }).catch(error => {
            //   console.error(error);
            // });
        } else {
            // Handle the case where no file is selected
            alert('Please select a file.');
        }
    };

    const validateSheet = (event) => {
        const fileInput = event.target;
        const file = fileInput.files[0];
        if (file) {
            // Check file size
            const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB
            if (file.size > maxSizeInBytes) {
                alert('File size exceeds 5 MB limit');
                // You can also reset the file input if needed
                fileInput.value = '';
                return;
            }

            // Check file format
            const allowedFileTypes = ['csv', 'tsv', 'xls', 'xlsx'];
            const fileNameParts = file.name.split('.');
            const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();

            if (!allowedFileTypes.includes(fileExtension)) {
                alert('Invalid file format. Allowed formats are: csv, tsv, xls, xlsx');
                // You can also reset the file input if needed
                fileInput.value = '';
                return;
            }
            setOpeningSheet(file);
        }
    };

    useEffect(() => {
        if (openingSheet) handleUploadOpeningBalance();
    }, [openingSheet]);

    const handleUploadOpeningBalance = async () => {
        try {
            //const org_id = useSelector((state) => (state?.account?.org?.id ? state?.account?.org?.id : state?.account?.org_data?.data?.id));
            const formData = new FormData();
            formData.append('file', openingSheet);
            formData.append('org_id', org_id);
            const res = await axiosInstance.post(configData.API_SERVER + 'organization/uploadOpeningInventory', formData);
            console.log('Response:', res.data);
        } catch (error) {
            // Handle error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log('Error response data:', error.response.data);
                console.log('Error response status:', error.response.status);

                // Check if the error is a result of email duplication
                if (error.response.status === 400 && error.response.data.message) {
                    // Display the error message to the user
                    alert(error.response.data.message);
                } else {
                    // Handle other types of errors accordingly
                    alert('Other error:', error.response.data);
                }
            } else if (error.request) {
                // The request was made but no response was received
                alert('Error request:', error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                alert('Error message:', error.message);
            }
        }
    };

    useEffect(() => {
        const fetchRoleData = async () => {
            const res = await axiosInstance.get(configData.API_SERVER + '/user/get_roles');
            if (role === 'Org Owner') {
                setRoles(res.data.filter((item) => item.role != 'Org Owner' && item.role != 'Super Admin'));
            }
            if (role === 'Department Head') {
                setRoles(
                    res.data.filter((item) => item.role != 'Org Owner' && item.role != 'Super Admin' && item.role != 'Department Head')
                );
            }
        };

        if (role === 'Org Owner' || role === 'Department Head') {
            fetchRoleData();
        }
    }, []);

    const memberSubmit = async (data) => {
        console.log(data);
        const res = await axiosInstance.post(configData.API_SERVER + '/organization/update_member/', data);
        console.log(res);
    };

    const getInventoryTemplate = async () => {
        console.log('sdhfhksdhfks');
        try {
            const response = await fetch('https://imagei.s3.ap-south-1.amazonaws.com/Template/Inventory+Template.xlsx');
            const blob = await response.blob();

            // Create a URL for the blob
            const url = window.URL.createObjectURL(blob);

            // Create an anchor element
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Opening_FG_Inventory_Template.xlsx'; // Specify the filename here

            // Append the anchor element to the document body
            document.body.appendChild(link);

            // Programmatically click the link to initiate the download
            link.click();

            // Remove the anchor element from the document body
            document.body.removeChild(link);
        } catch (error) {
            console.log(error);
        }
    };


    return (
        <React.Fragment>
            {role === 'Super Admin' && !org_member_data?.isOrgUpdated && !isOrgMemberFlag && (
                <MainCard style={{ color: ' ' }} title="Organization Profile" secondary={<SecondaryAction />}>
                    <Typography variant="subtitle1">Branding</Typography>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                            <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                                <div className="uploadFile">
                                    <div className="uploadBorder">
                                        <Label
                                            htmlFor="hiddenFileInput"
                                            id="chooseFileButton"
                                            className="chooseFileBtn"
                                            style={{ cursor: 'pointer', marginTop: '25px' }}
                                        >
                                            <svg
                                                style={{ height: '16px', width: '18px', marginRight: '10px', color: 'gray' }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 477.981 397.925"
                                                class="icon fill-grey align-middle mb-1"
                                            >
                                                <path d="M337.871 89.11L255.661 6.9c-4.6-4.6-10.64-6.9-16.67-6.9s-12.07 2.3-16.67 6.9l-82.21 82.21c-9.2 9.21-9.2 24.13 0 33.34 9.21 9.21 24.14 9.21 33.35 0l41.95-41.95v168.85c0 13.03 10.56 23.58 23.58 23.58s23.58-10.55 23.58-23.58V80.5l41.95 41.95c9.21 9.21 24.14 9.21 33.35 0 9.2-9.21 9.2-24.13 0-33.34z"></path>
                                                <path d="M393.786 397.925H84.195C37.769 397.925 0 357.129 0 306.984V216.81c0-13.021 10.556-23.577 23.577-23.577s23.577 10.556 23.577 23.577v90.174c0 24.144 16.616 43.787 37.041 43.787h309.591c20.425 0 37.041-19.643 37.041-43.787v-91.272c0-13.021 10.556-23.577 23.577-23.577s23.577 10.556 23.577 23.577v91.272c0 50.145-37.77 90.941-84.195 90.941z"></path>
                                            </svg>
                                            {selectedFile ? 'Replace File' : 'Upload Your Organization Logo'}
                                        </Label>
                                        <br></br>

                                        <input
                                            // name="resultUpload"
                                            type="file"
                                            style={{ display: 'none' }}
                                            id="hiddenFileInput"
                                            onChange={handleFileChange}
                                            // {...register('logo', { required: 'Organization Logo Is Required'})}
                                        />
                                    </div>
                                    <div className="uploadInfo">
                                        {/* <p style={{ marginTop: '2px', fontSize: '12px' }}>Supported formats: PNG, JPEG, JPG</p> */}
                                        <p style={{ marginTop: '2px', marginBottom: '0', fontSize: '12px' }}>
                                            Supported formats: PNG, JPEG, JPG
                                        </p>
                                        <p style={{ margin: '0', fontSize: '12px' }}>Maximum File Size: 1MB</p>
                                        <p style={{ margin: '0', fontSize: '12px' }}>
                                            {selectedFile ? selectedFile.name : 'No Files Uploaded'}
                                        </p>
                                    </div>
                                </div>
                                <br></br>
                            </Grid>
                        </Grid>
                        <Divider />

                        <Typography variant="subtitle1" style={{ marginTop: '2vh' }}>
                            Company Details
                        </Typography>
                        <Grid container spacing={gridSpacing}>
                            <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                                <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                    <Label style={{ fontSize: '14px !important' }}>
                                        Organization Name<span style={{ color: 'red' }}>*</span>
                                    </Label>
                                </Grid>
                                <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                    <input
                                        // type="text"
                                        className="form-control "
                                        placeholder="Enter your organization name"
                                        {...register('name', { required: 'Organization Name Is Required' })}
                                    />
                                    {errors.name && (
                                        <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>{errors.name.message}</p>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1" style={{ marginTop: '-2rem' }}>
                                <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                    <Label style={{ fontSize: '14px !important' }}>
                                        Industry<span style={{ color: 'red' }}>*</span>
                                    </Label>
                                </Grid>
                                <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                    <select
                                        className="form-select "
                                        style={{ cursor: 'pointer' }}
                                        {...register('industry', { required: 'Please Select Industry' })}
                                    >
                                        {/* <option value={''} style={{ color: 'gray' }}>
                                            Select Industry
                                        </option> */}
                                        {Industry.map((item) => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            );
                                        })}
                                    </select>
                                    {errors.industry && (
                                        <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>
                                            {errors.industry.message}
                                        </p>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1" style={{ marginTop: '-2rem' }}>
                                <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                    <Label style={{ fontSize: '14px !important' }}>
                                        Business Address<span style={{ color: 'red' }}>*</span>
                                    </Label>
                                </Grid>
                                <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                    <input
                                        // type="text"
                                        className="form-control "
                                        placeholder="Address"
                                        style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                        {...register('address', { required: 'Address Is Required' })}
                                    />
                                    {errors.address && (
                                        <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>{errors.address.message}</p>
                                    )}
                                    <input
                                        // type="text"
                                        className="form-control "
                                        placeholder="Enter Your City"
                                        style={{ marginBottom: '1.3vh' }}
                                        {...register('city', { required: 'City is Required' })}
                                    />
                                    {errors.city && (
                                        <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>{errors.city.message}</p>
                                    )}
                                    <select
                                        className="form-select "
                                        style={{ cursor: 'pointer' }}
                                        {...register('state', { required: 'Please Select State' })}
                                    >
                                        {/* <option  style={{ color: 'gray' }}>
                                            Select State
                                        </option> */}
                                        {states.map((item) => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            );
                                        })}
                                    </select>
                                    {errors.state && (
                                        <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>{errors.state.message}</p>
                                    )}
                                </Grid>
                            </Grid>

                            <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1" style={{ marginTop: '-2rem' }}>
                                <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                    <Label style={{ fontSize: '14px !important' }}>
                                        Primary Contact<span style={{ color: 'red' }}>*</span>
                                    </Label>
                                </Grid>
                                <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                    <input
                                        // type="email"
                                        className="form-control "
                                        placeholder="Enter Email-id"
                                        style={{ marginBottom: '1.3vh' }}
                                        // aria-invalid={errors.email ? "true" : "false"}
                                        {...register('email', {
                                            required: 'Email is Required',
                                            pattern: {
                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                message: 'Invalid email address'
                                            }
                                        })}
                                    />
                                    {errors.email && (
                                        <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>{errors.email.message}</p>
                                    )}
                                    {/* <input
                                        type="password"
                                        name="password"
                                        className="form-control "
                                        placeholder="Password for Org Login"
                                        style={{ marginBottom: '1.3vh' }}
                                        // aria-invalid={errors.email ? "true" : "false"}
                                        {...register('password', {
                                            required: 'Password is Required'
                                        })}
                                        autoComplete="new-password"
                                    />
                                    {errors.password && (
                                        <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-10px' }}>
                                            {errors.password.message}
                                        </p>
                                    )} */}

                                    <input
                                        type="number"
                                        className="form-control "
                                        placeholder="Enter Phone"
                                        {...register('phone', {
                                            required: 'Invalid Mobile Number'
                                            // pattern: {
                                            //     // value: /^\+[1-9]\d{1,10}$/,
                                            //     message: 'Invalid mobile number'
                                            // }
                                        })}
                                    />
                                    {errors.phone && (
                                        <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>{errors.phone.message}</p>
                                    )}
                                </Grid>
                            </Grid>

                            <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid" style={{ marginTop: '-2rem' }}>
                                <Grid lg={4} sm={6}>
                                    <br></br>
                                    <Button
                                        type="submit"
                                        variant="outlined"
                                        style={{ marginLeft: '15px', marginTop: '10px' }}
                                        onClick={() => handleSubmit(onSubmit)}
                                        // onClick={resetFilterData}
                                    >
                                        Save Details
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                    <Divider />
                </MainCard>
            )}

            {((role === 'Super Admin' && org_member_data?.isOrgUpdated) || isOrgMemberFlag) && (
                <MainCard style={{ color: ' ' }} title="Organization Profile" secondary={<SecondaryAction />}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item lg={12} sm={12} md={12} container spacing={5} className="al_sl__main_grid1  m-0">
                            <Grid item lg={3} md={2} sm={12} xs={12} className="sad_Single ">
                                <div
                                    className=" shadow"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        border: '0px solid #b8b8b8',
                                        borderRadius: '3px',
                                        height: '20vh',
                                        width: '100%'
                                    }}
                                >
                                    { logoUrl ? (<img
                                        srcSet={`${logoUrl ? logoUrl : org_data?.logo_url}`}
                                        src={`${logoUrl ? logoUrl : org_data?.logo_url}`}
                                        alt="Company Logo"
                                        loading="lazy"
                                        style={{
                                            height: '100%',
                                            width: '65%',
                                            objectFit: 'contain',
                                            objectPosition: 'center',
                                        }}                                            
                                    />) : (<p style={{ fontSize: '10px', marginTop: '20px'}}>Company Logo Not Uploaded</p>)}
                                </div>
                            </Grid>
                            <Grid item lg={6} md={12} sm={12} xs={12} className="sad_Single">
                                <p style={{ fontSize: '25px', fontFamily: 'sans-serif', marginBottom: '0' }}>
                                    {org_member ? org_member.memberName : org_member_data ? org_member_data.memberName : null}
                                </p>
                                <p
                                    style={{
                                        fontFamily: 'sans-serif',
                                        fontWeight: '600',
                                        color: '#0d6efd',
                                        fontStyle: 'italic',
                                        marginTop: '0',
                                        fontSize: '12px'
                                    }}
                                >
                                    CEO
                                </p>
                                <span></span>
                                <p style={{ marginTop: '0' }}>
                                    <IconMail stroke={1.5} size="1.3rem" />
                                    &nbsp;{org_member ? org_member.email : org_member_data ? org_member_data.email : null}
                                </p>
                                <p style={{ marginTop: '0' }}>
                                    <IconPhone stroke={1.5} size="1.3rem" />{' '}
                                    {org_member ? org_member.phone : org_member_data ? org_member_data.phone : null}
                                </p>
                            </Grid>
                        </Grid>

                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1 pt-0 ">
                            <Grid item lg={12} md={12} sm={12} xs={12} className="sad_Single" style={{ paddingBottom: '0' }}>
                                <p style={{ fontSize: '12px', letterSpacing: '1px', color: '#b8b8b8' }}>COMPANY INFORMATION</p>
                            </Grid>
                        </Grid>
                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1 pt-0">
                            <Grid item lg={1} md={12} sm={12} xs={12} className="sad_Single pt-0">
                                <p style={{ fontSize: '13px', letterSpacing: '1px' }}>Phone:</p>
                                <p style={{ fontSize: '13px', letterSpacing: '1px' }}>Address:</p>
                                <p style={{ fontSize: '13px', letterSpacing: '1px' }}>Email:</p>
                            </Grid>
                            <Grid item lg={4} md={12} sm={12} xs={12} className="sad_Single pt-0">
                                <p style={{ fontSize: '13px', letterSpacing: '1px' }}>
                                    {org ? org.phone : org_data ? org_data.phone : null}
                                </p>
                                <p style={{ fontSize: '13px', letterSpacing: '1px' }}>
                                    {org ? org.address : org_data ? org_data.address : null}
                                </p>
                                <p style={{ fontSize: '13px', letterSpacing: '1px' }}>
                                    {org ? org.email : org_data ? org_data.email : null}
                                </p>
                            </Grid>
                        </Grid>
                    </Grid>
                </MainCard>
            )}

            {role === 'Super Admin' && (
                <MainCard style={{ color: ' ', marginTop: '2vh' }} title="Opening Balance & Historical TB" secondary={<SecondaryAction />}>
                    <Grid container spacing={gridSpacing}>
                        <Grid item lg={6} sm={12} md={12} className="al_sl__main_grid1">
                            <div className="uploadMainOpening">
                                <div className="uploadOpening">
                                    <img className="uploadCloud" src={uploadCloud} alt="" />
                                    <Label>Import Opening FG Inventory Sheet</Label>
                                    <div style={{ padding: '0 10px' }}>
                                        <Label
                                            htmlFor="hiddenFileInput1"
                                            id="chooseFileButton"
                                            className="chooseFileBtn1"
                                            style={{
                                                cursor: 'pointer',
                                                color: 'white',
                                                background: '#2196f3',
                                                borderRadius: '4px',
                                                padding: '5.5px 13px',
                                                marginRight: '3px'
                                            }}
                                        >
                                            Choose File
                                        </Label>
                                        <Label
                                            id="chooseFileButton1"
                                            className="chooseFileBtn1"
                                            style={{
                                                cursor: 'pointer',
                                                color: 'white',
                                                background: '#198754',
                                                borderRadius: '4px',
                                                padding: '5.5px 10px',
                                                marginLeft: '3px'
                                            }}
                                            onClick={() => {
                                                getInventoryTemplate()
                                            }}
                                        >
                                            <IconDownload stroke={1.5} size="1.2rem" style={{ marginTop: '-6px' }} />
                                        </Label>
                                        <Tooltip
                                            isOpen={tooltipOpen}
                                            target="chooseFileButton1" // ID of the target element
                                            toggle={toggleTooltip} // Toggle function
                                        >
                                            Download Opening FG Inventory Template
                                        </Tooltip>
                                    </div>

                                    <input
                                        name="resultUpload"
                                        type="file"
                                        style={{ display: 'none' }}
                                        id="hiddenFileInput1"
                                        onChange={validateSheet}
                                    />
                                    <div style={{ display: 'flex' }}>
                                        <span style={{ fontSize: '12.7px', fontWeight: '400' }}>Maximum File Size: 5 MB </span>
                                        <span style={{ fontSize: '23px', margin: '-9px 3px 0 3px' }}>•</span>
                                        <span style={{ fontSize: '12.7px', fontWeight: '400' }}> File Format: CSV or TSV or XLS</span>
                                    </div>
                                </div>
                            </div>
                        </Grid>

                        <Grid item lg={6} sm={12} md={12} className="al_sl__main_grid1">
                            <div className="uploadMainOpening">
                                <div className="uploadOpening">
                                    <img className="uploadCloud" src={uploadCloud} alt="" />
                                    <Label>Import Historical TB</Label>
                                    <label
                                        htmlFor="hiddenFileInput1"
                                        id="chooseFileButton"
                                        className="chooseFileBtn1"
                                        style={{
                                            cursor: 'pointer',
                                            color: 'white',
                                            background: '#2196f3',
                                            borderRadius: '4px',
                                            padding: '5.5px 13px'
                                        }}
                                    >
                                        Choose File
                                    </label>
                                    <input
                                        name="resultUpload"
                                        type="file"
                                        style={{ display: 'none' }}
                                        id="hiddenFileInput1"
                                        // onChange={validateSheet}
                                    />
                                    <div style={{ display: 'flex' }}>
                                        <span style={{ fontSize: '12.7px', fontWeight: '400' }}>Maximum File Size: 5 MB </span>
                                        <span style={{ fontSize: '23px', margin: '-9px 3px 0 3px' }}>•</span>
                                        <span style={{ fontSize: '12.7px', fontWeight: '400' }}> File Format: CSV or TSV or XLS</span>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </MainCard>
            )}

            <Grid item xs={12} className="sub_div">
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} md={6} sm={6} xs={12}>
                        <Grid className="col-12 col-sm-12 text-center footer_inner_div">&copy; {new Date().getFullYear()} IMAGE-I</Grid>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default CasingDamageReport;
